import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable()
export class AuthenticationGuard {
  constructor(private router: Router, public authService: AuthService) {}

  canActivate(): Observable<boolean> {
    const returnObservable = this.authService.isAuthenticated$.pipe(
      tap((isAuthenticated) => {
        if (!isAuthenticated) {
          localStorage.clear();
          this.router.navigate(["/login"]);
        }
      }),
      map((isAuthenticated) => isAuthenticated)
    );
    return returnObservable;
  }
}
